export class AddressModel {
    addressId: number;
    doorNo: string;
    street: string;
    locality: string;
    city: string;
    state: string;
    country: string;
    pincode: string;
    createdAt: Date | any;
    updatedAt: Date | any;
    createdUser: string;
    updatedUser: string;
    versionFlag: number;
    constructor(addressId: number, doorNo: string, street: string, locality: string, city: string, state: string, country: string, pincode: string, createdAt: Date | any, updatedAt: Date | any, createdUser: string, updatedUser: string, versionFlag: number) {
        this.addressId = addressId;
        this.doorNo = doorNo;
        this.street = street;
        this.locality = locality;
        this.city = city;
        this.state = state;
        this.country = country;
        this.pincode = pincode;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
}



export const AddressModelDefault: AddressModel = {
    addressId: 0,
    doorNo: '',
    street: '',
    locality: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    createdUser: '',
    updatedUser: '',
    versionFlag: 0
}